<template>
    <div class="file-preview" :class="files.length ? 'active' : null">
        <div ref="wrapper" v-if="currentFile" @click="closeBackdrop">
            <div class="content-wrapper" :class="isVideo(currentFile) ? 'is-video' : null" @click="closeBackdrop" ref="contentWrapper">
                <div class="change-image-btn previous" @click.prevent="changeIndex('previous')" v-if="files.length > 1">
                    <icon name="chevron-left"/>
                </div>
                <img v-if="isImage(currentFile)" :src="src"/>
                <video-player v-if="isVideo(currentFile)" :src="{ src }"/>
                <div class="change-image-btn next" @click.prevent="changeIndex('next')" v-if="files.length > 1">
                    <icon name="chevron-right"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import FileMixin from "../mixins/FileMixin";
    import VideoPlayer from "./VideoPlayer";

    export default {
        components: {
            VideoPlayer
        },

        mixins: [
            FileMixin
        ],

        props: {
            ceremonyCode: {
                type: String,
                required: true
            },

            files: {
                type: Array,
                required: true,
                default() {
                    return []
                }
            },

            fileIndex: {
                required: false,
                default: null,
            }
        },

        watch: {
            files() {
                this.currentFileIndex = this.files.length ? 0 : null;
            },

            fileIndex() {
                this.currentFileIndex = this.fileIndex
            }
        },

        computed: {
            src() {
                if(!this.currentFile){
                    return null;
                }

                return this.currentFile.public_path.replace(/\/:code\//g, '/' + this.ceremonyCode + '/');
            },
            currentFile() {
                if (this.currentFileIndex === null) {
                    return null;
                }

                return this.files[this.currentFileIndex];
            }
        },

        data() {
            return {
                currentFileIndex: this.fileIndex
            }
        },

        mounted() {
            document.addEventListener('keydown', (event) => {
                if (!this.files.length) {
                    return;
                }

                if (event.key === 'Escape') {
                    this.close();

                    return;
                }

                if (event.key === 'ArrowRight') {
                    this.changeIndex('next')
                }

                if (event.key === 'ArrowLeft') {
                    this.changeIndex('previous')
                }
            });
        },

        methods: {
            changeIndex(direction) {
                let newIndex = this.currentFileIndex;

                if (direction === 'next') {
                    newIndex++;
                }

                if (direction === 'previous') {
                    newIndex--;
                }

                if (newIndex < 0) {
                    newIndex = this.files.length - 1;
                } else if (newIndex > this.files.length - 1) {
                    newIndex = 0;
                }

                this.currentFileIndex = newIndex;
            },

            closeBackdrop($event) {
                if ($event.target === this.$refs.wrapper || $event.target === this.$refs.contentWrapper) {
                    this.close();
                }
            },

            close() {
                this.$emit('clear');
            }
        }
    }

</script>

<style lang="scss" scoped>

    .file-preview {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        background-color: rgba(0, 0, 0, 0.4);
        opacity: 0;
        pointer-events: none;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: 150ms ease opacity;

        &.active {
            opacity: 1;
            pointer-events: all;
        }

        .videoWrapper,
        .livevideoWrapper,
        img {
            max-height: 80vh;
            max-width: 1200px;

            @media(max-width: 1300px){
                max-width: 80vw;
            }
        }

        > div,
        > div .content-wrapper.is-video,
        > div .videoWrapper,
        > div .livevideoWrapper {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 30px;
        }

        .livevideoWrapper,
        .videoWrapper {
            height: auto !important;
        }

        .content-wrapper {
            position: relative;
        }

        .change-image-btn {
            height: 100%;
            position: absolute;
            width: calc(50% + 60px);
            display: inline-flex;
            align-items: center;
            color: #fff;
            fill: #fff;
            cursor: pointer;

            svg {
                color: #fff;
                fill: #fff;
            }

            * {
                width: 40px;
                height: 40px;
            }

            &.previous {
                left: -60px;
                justify-content: flex-start;

                @media(max-width: 767px){
                    left: -40px;
                }
            }

            &.next {
                right: -60px;
                justify-content: flex-end;

                @media(max-width: 767px){
                    right: -40px;
                }
            }
        }

        .content-wrapper.is-video .change-image-btn {
            position: relative;
            height: 54.25%;
            width: 60px;
            justify-content: center;
            right: initial;
            left: initial;

            &.previous {
                margin-right: -30px;
            }

            &.next {
                margin-left: -30px;
            }
        }
    }

</style>
